export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

// News Source
export const SET_SOURCE_LOADING = 'SET_SOURCE_LOADING';
export const GET_NEWS_SOURCE = 'GET_NEWS_SOURCE';
export const NEWS_SOURCE_ERROR = 'NEWS_SOURCE_ERROR';
// News
export const SET_NEWS_LOADING = 'SET_NEWS_LOADING';
export const SET_TOP_NEWS = 'SET_TOP_NEWS';
export const CLEAR_TOP_NEWS = 'CLEAR_TOP_NEWS';
export const TOP_NEWS_ERROR = 'TOP_NEWS_ERROR';

// Set Theme
export const SET_THEME = 'SET_THEME';
export const CHANGE_THEME = 'CHANGE_THEME';
// Bookmark
export const BOOKMARK_ITEM = 'BOOKMARK_ITEM';
export const UNBOOKMARK_ITEM = 'UNBOOKMARK_ITEM';
export const GET_BOOKMARK_ITEMS = 'GET_BOOKMARK_ITEMS';

